@if (!summary) {
  <mat-form-field class="w-100"
    >
    <mat-label>
      {{label}}
    </mat-label>
    <mat-select [(ngModel)]="questionModel"
      (selectionChange)="onModelChange()"
      required
      [formControl]="control">
      @for (question of questions; track question) {
        <mat-option
          [value]="question.questionNumber"
          [id]="question.questionNumber">
          {{question.editLabel | localized}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
@if (!control?.valid && control?.touched) {
  <mat-error>
    {{'form.validation.required' | translate}}
  </mat-error>
}
@if (summary) {
  <p>
    <label>{{label}}</label>
    <span style="display: block"
    class="font-weight-bold">{{ getSummaryLabel() | localized}}</span>
  </p>
}